// extracted by mini-css-extract-plugin
export var iconPhoneFirst = "styles-module--iconPhoneFirst--oeUIu";
export var showWave = "styles-module--showWave--U3EO8";
export var iconPhoneSecond = "styles-module--iconPhoneSecond--l0HaC";
export var iconPhoneThird = "styles-module--iconPhoneThird--R7Gtl";
export var iconWeb = "styles-module--iconWeb--zHQq3";
export var spin = "styles-module--spin--XA1pI";
export var web = "styles-module--web--OEOIH";